import { AIUploadChatContainer } from '@/components/chat/AIUploadChatContainer';

export default function AIUploadPage() {
  return (
    <div className="h-[calc(100vh-64px)]">
      <AIUploadChatContainer />
    </div>
  );
}
